import { Injectable } from '@angular/core';
import { Observable, of } from 'rxjs';
import { WebService } from '../services/web.service';

@Injectable({
  providedIn: 'root'
})
export class UserService {
  userList: any=[];
  constructor(
    private webapi: WebService,
   
) { }
  getUsers() {
    return new Promise((resolve, reject) => {
        this.webapi.requestJson('getUser', null) 
        .subscribe(
            data => {
                let response = JSON.parse(data.body);
                this.userList = [...response.data];
                resolve(true)
            },
            error => {
                return(true)
            }
        )
    })
  }


}